<div fxLayout="row" fxLayoutAlign="left" fxLayoutGap="10px" style="width:100%" [formGroup]="orderForm">
  <div fxFlex="calc(100%-160px)" formGroupName="products">
    <ng-container [formGroupName]="0">
      <div fxLayout="row" fxLayoutAlign="left" fxLayoutGap="10px" style="width:100%">
        <div fxFlex="1 1 190px" formGroupName="lens">
          <mat-form-field style="width:100%">
            <mat-label>LAB</mat-label>
            <input matInput placeholder="LAB" formControlName="lab" />
          </mat-form-field>
        </div>
        <div fxFlex="1 1 190px" formGroupName="product">
          <app-autocomplete-vendors
            placeholder="MANUFACTURER"
            [(productForm)]="orderForm.controls.products['controls'][0]['controls']['product']"
            fxFlex="1 1 100%"
          ></app-autocomplete-vendors>
        </div>
        <div fxFlex="1 1 auto" formGroupName="frame">
          <div fxLayout="row wrap" fxLayoutGap="10px">
            <mat-checkbox formControlName="modification">R. HINGE</mat-checkbox>
            <mat-checkbox formControlName="hold">L. HINGE</mat-checkbox>
            <mat-checkbox formControlName="patientToSupply">R. TEMPLE</mat-checkbox>
            <mat-checkbox formControlName="enclosed">L. TEMPLE</mat-checkbox>
            <mat-checkbox formControlName="approved">FRONT</mat-checkbox>
            <mat-checkbox formControlName="callPatient">BRIDGE</mat-checkbox>
          </div>
        </div>
      </div>

      <div fxLayout="row" fxLayoutAlign="left" fxLayoutGap="10px" style="width:100%">
        <div fxFlex="1 1 60%" formGroupName="frame">
          <mat-form-field appearance="fill" style="width:100%">
            <mat-label>FRAME REPAIR NOTES</mat-label>
            <textarea matInput rows="4" formControlName="notes"></textarea>
          </mat-form-field>
        </div>
        <div fxFlex="1 1 20%" formGroupName="frame">
          <mat-checkbox formControlName="modification">PARTS</mat-checkbox>
          <mat-form-field style="width:100%">
            <input matInput placeholder="PARTS" type="text" formControlName="modificationPrice" />
            <span matPrefix>$&nbsp;</span>
          </mat-form-field>
        </div>
        <div fxFlex="1 1 20%" formGroupName="frame">
          <mat-checkbox formControlName="failedInspection">OTHER</mat-checkbox>
          <mat-form-field style="width:100%">
            <input matInput placeholder="OTHER" type="text" formControlName="modificationDetails" />
            <span matPrefix>$&nbsp;</span>
          </mat-form-field>
        </div>
      </div>

      <div fxLayout="row" fxLayoutAlign="left" fxLayoutGap="10px" style="width:100%">
        <div fxFlex="0 0 150px">
          <div class="image-placeholder">ADD INVOICE IMAGE</div>
          <div class="image-placeholder">ADD IMAGE</div>
        </div>
        <div fxFlex="0 0 310px" formGroupName="frame">
          <mat-checkbox formControlName="pof">EST. APPROVAL REQ.</mat-checkbox>
          <mat-form-field style="width:150px;">
            <mat-label>ORDER DATE</mat-label>
            <input matInput [matDatepicker]="pickerOrderDate" formControlName="orderDate" />
            <mat-datepicker-toggle matSuffix [for]="pickerOrderDate"></mat-datepicker-toggle>
            <mat-datepicker #pickerOrderDate></mat-datepicker>
          </mat-form-field>
          <mat-form-field style="width:120px;">
            <input matInput placeholder="ORDER #" formControlName="dueDate" />
          </mat-form-field>
        </div>
      </div>
    </ng-container>
  </div>
  <mat-checkbox formControlName="warranty" style="margin-bottom: 12px;">WARRANTY</mat-checkbox>

  <div fxFlex="0 0 150px">
    <mat-card formGroupName="products">
      <mat-card-content [formGroupName]="0">
        <div formGroupName="frame">
          <mat-checkbox formControlName="duty">NO TAX</mat-checkbox>
          <mat-form-field style="width:100%">
            <input matInput placeholder="TAX" type="text" formControlName="price" />
            <span matPrefix>$&nbsp;</span>
          </mat-form-field>
          <mat-form-field style="width:100%">
            <input matInput placeholder="ESTIMATE" type="text" formControlName="estimate" />
            <span matPrefix>$&nbsp;</span>
          </mat-form-field>
          <mat-form-field style="width:100%">
            <input matInput placeholder="REPAIR" type="text" formControlName="deposit" />
            <span matPrefix>$&nbsp;</span>
          </mat-form-field>
        </div>
        <mat-form-field style="width:100%">
          <input matInput placeholder="TOTAL" type="text" formControlName="cost" />
          <span matPrefix>$&nbsp;</span>
        </mat-form-field>
      </mat-card-content>
    </mat-card>

    <mat-card style="margin-top:10px;">
      <mat-card-content>
        <mat-form-field style="width:100%">
          <input matInput placeholder="LAST EDITOR" type="text" disabled />
          <span matPrefix>KM&nbsp;</span>
        </mat-form-field>

        <mat-form-field style="width:35px;flex: 0 1 35px;padding-left:10px;" floatLabel="never">
          <input matInput required placeholder="" type="text" formControlName="initials" />
          <mat-label><mat-icon>gesture</mat-icon></mat-label>
        </mat-form-field>

        <button mat-button [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
          <span>SAVE</span>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item type="button" style="margin-left:10px;" (click)="onSave('ORDERED')">REPAIR</button>
          <button mat-menu-item type="button" style="margin-left:10px;" (click)="onSave('SAVE')">WARRANTY</button>
          <button mat-menu-item type="button" style="margin-left:10px;" (click)="onSave('SAVE')">SAVE/HOLD</button>
          <button mat-menu-item type="button" style="margin-left:10px;" (click)="onSave('SAVE')">VOID</button>
        </mat-menu>
      </mat-card-content>
    </mat-card>
  </div>
</div>
